module.exports = __webpack_public_path__ + "img/agent-group-1.b60938a3.png";